// extracted by mini-css-extract-plugin
export default {"CircleText":"CircleText_CircleText__uuH3Y","spin":"CircleText_spin__bS55V"};